import {connect} from 'react-redux';
import OverviewScreen from '../../components/screens/OverviewScreen';
import {getProjectOverview, getCampingStats} from '../../actions/overviewAction';

const mapStateToProps = state => {
    return {
        username: state.authorization.username,
        projectOverview: state.overview.projectOverview,
        campingStats: state.overview.campingStats
    }
};

const mapDispatchToProps = dispatch => {
    return {
        getProjectOverview: () => {
            dispatch(getProjectOverview())
        },
        getCampingStats: () => {
            dispatch(getCampingStats())
        }
    }
};

const OverviewScreenContainer = connect(
    mapStateToProps,
    mapDispatchToProps
)(OverviewScreen);

export default OverviewScreenContainer;